import { render, staticRenderFns } from "./RedCone.vue?vue&type=template&id=789bf9f3&"
import script from "./RedCone.vue?vue&type=script&lang=js&"
export * from "./RedCone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports